export const getCategoryImageUrl = (item) => {
    const objectPath = item?.imagePath || (item?.image ? `categories/${item.image}` : '')
    return objectPath ? `https://storage.googleapis.com/canvasexpress/${objectPath}` : '/assets/images/placeholder.jpg'
}

export const getArtistCoverImageUrl = (item) => {
    const objectPath = item?.artistCoverImagePath || (item?.artistCoverImage ? `categories/${item.artistCoverImage}` : '')
    return objectPath ? `https://storage.googleapis.com/canvasexpress/${objectPath}` : getCategoryImageUrl(item)
}

export const validateCategoryUpload = (data) => {
    if (!data?.success || !data.fileName || !data.path) throw new Error('Incomplete category upload response')
    return data
}
